import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageProvider";

function getRootElement() {
    let rootElement = document.getElementById("root");

    if (!rootElement) {
        rootElement = document.createElement("div");
        rootElement.id = "root";
        document.body.prepend(rootElement);
    }

    return rootElement;
}

function mountApp() {
    const root = ReactDOM.createRoot(getRootElement());

    root.render(
        <React.StrictMode>
            <BrowserRouter>
                <LanguageProvider>
                    <App />
                </LanguageProvider>
            </BrowserRouter>
        </React.StrictMode>,
    );
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountApp, { once: true });
} else {
    mountApp();
}
